<template>
  <div>
    <div class="contents">
      <span class="mb-2 icon badge bg-pink text-capitalize">
        {{ eventinfo.awardtype | awardtype }} /
        {{ event_type(eventinfo.award_fk) }}
      </span>
      <h4 class="subtitle">
        {{ eventinfo.title }}
      </h4>
      <p class="mb-4 lh-sm" v-if="eventinfo.standard_point != 0">
        <span> {{ $t("title.common.point_allocation") }} : </span>
        <span class="text-point-sp">
          {{ $t("title.common.standard_point") }}
        </span>
      </p>
      <div class="mb-4 border">
        <h6 class="p-3 bg-lightgray border-bottom">
          {{ $t("title.event.prize_rank") }}
        </h6>
        <div class="row row-cols-1 row-cols-sm-3 g-2 g-sm-3 p-2 p-sm-3">
          <template v-for="(item, index) in awardprizeranklist">
            <div :key="'a' + index" class="col">
              <div class="card h-100">
                <div class="card-body">
                  <h6 class="card-title fs-6">
                    {{ $t("title.common.top_rank") }} {{ item.rank_no }}
                  </h6>
                  <p class="card-text pt-1 lh-sm text-prize">
                    {{ item.prize }}
                  </p>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <table class="table board toggle-xxl">
        <thead>
          <tr v-if="eventinfo.award_fk == '11'">
            <th class="col-auto d-lg-table-cell">
              {{ $t("title.common.ranking") }}
            </th>
            <th class="col-auto d-lg-table-cell">
              {{ $t("title.common.winner") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.common.course") }}({{ $t("title.common.hole") }})
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.location") }}
            </th>
            <th class="col-auto d-none d-sm-table-cell">
              {{ $t("title.common.distance") }}
            </th>
            <th class="col-auto d-none d-md-table-cell w-1">
              {{ $t("title.common.no_of_play") }}
            </th>
            <th
              class="col-auto d-none d-xxl-table-cell w-1"
              v-if="eventinfo.standard_point != 0"
            >
              {{ $t("title.common.standard_point") }}
            </th>
            <th class="th-arrow"></th>
          </tr>
          <tr v-if="eventinfo.award_fk == '12'">
            <th class="col-auto d-lg-table-cell">
              {{ $t("title.common.ranking") }}
            </th>
            <th class="col-auto d-lg-table-cell">
              {{ $t("title.common.winner") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.common.course") }}({{ $t("title.common.hole") }})
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.location") }}
            </th>
            <th class="col-auto d-none d-sm-table-cell">
              {{ $t("title.common.distance") }}
            </th>
            <th class="col-auto d-none d-md-table-cell w-1">
              {{ $t("title.common.no_of_play") }}
            </th>
            <th
              class="col-auto d-none d-md-table-cell w-1"
              v-if="eventinfo.standard_point != 0"
            >
              {{ $t("title.common.standard_point") }}
            </th>

            <!-- <th class="col-auto d-none d-xxl-table-cell">
              Final Score<br />(Correction value)
            </th> -->
            <th class="th-arrow"></th>
          </tr>
        </thead>

        <tbody v-if="data_yn && eventinfo.award_fk == '11'">
          <template v-for="(item, index) in items">
            <tr :key="index">
              <td class="col-auto d-lg-table-cell w-1">
                <strong class="text-black">{{
                  item.eventwinningrankinfo.rank
                }}</strong>
              </td>
              <td class="col-auto d-lg-table-cell text-start">
                <MemberInfo
                  :nickname="item.eventwinningrankinfo.nickname"
                  :playerno="item.eventwinningrankinfo.playerno"
                  :member_img="item.eventwinningrankinfo.member_img"
                  :badge_img="item.eventwinningrankinfo.badge_img"
                />
              </td>
              <td class="col-auto d-none d-xxl-table-cell">
                <template v-for="(course, index_n) in item.coursescore">
                  <span :key="index_n + 'l1'">
                    {{ course.coursename }}
                    {{ course.subcoursename }}({{
                      item.eventwinningrankinfo.hole
                    }}H)
                  </span>
                </template>
              </td>
              <td class="col-auto d-none d-xl-table-cell shop-name">
                {{ item.eventwinningrankinfo.shopname }}
              </td>
              <td class="col-auto d-none d-sm-table-cell">
                {{ item.eventwinningrankinfo.longest }}m
              </td>
              <td class="col-auto d-none d-md-table-cell text-red">
                {{ item.eventwinningrankinfo.entrycnt }} /
                {{ item.eventwinningrankinfo.entrylimit | transToValue("∞") }}
              </td>
              <td
                class="col-auto d-none d-xxl-table-cell text-point-sp"
                v-if="eventinfo.standard_point != 0"
              >
                {{
                  item.eventwinningrankinfo.standard_point | comma | suffix("P")
                }}
              </td>
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-xxl-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="7">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.course") }}
                    </div>
                    <div class="col-8">
                      <template v-for="(course, index_n) in item.coursescore">
                        <span :key="index_n + 'l1'">
                          {{ course.coursename }}
                          {{ course.subcoursename }}
                        </span>
                      </template>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.hole") }}
                    </div>
                    <div class="col-8">
                      {{ item.eventwinningrankinfo.hole }}H
                    </div>
                  </div>

                  <div class="row d-xl-none">
                    <div class="col-4">
                      {{ $t("title.common.location") }}
                    </div>
                    <div class="col-8 shop-name">
                      {{ item.eventwinningrankinfo.shopname }}
                    </div>
                  </div>

                  <div class="row d-sm-none">
                    <div class="col-4">
                      {{ $t("title.common.distance") }}
                    </div>
                    <div class="col-8">
                      {{ item.eventwinningrankinfo.longest }}m
                    </div>
                  </div>

                  <div class="row d-md-none">
                    <div class="col-4">
                      {{ $t("title.common.no_of_play") }}
                    </div>
                    <div class="col-8 text-red">
                      {{ item.eventwinningrankinfo.entrycnt }} /
                      {{
                        item.eventwinningrankinfo.entrylimit | transToValue("∞")
                      }}
                    </div>
                  </div>

                  <div
                    class="row d-md-none"
                    v-if="eventinfo.standard_point != 0"
                  >
                    <div class="col-4">
                      {{ $t("title.common.standard_point") }}
                    </div>
                    <div class="col-8 text-point-sp">
                      {{
                        item.eventwinningrankinfo.standard_points
                          | comma
                          | suffix("P")
                      }}
                    </div>
                  </div>
                  <!-- <div class="row">
                    <div class="col-4">Final Score<br />(Correction value)</div>
                    <div class="col-8">
                      {{ item.eventwinningrankinfo.newperiolastscore | comma }}
                    </div>
                  </div> -->
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else-if="data_yn && eventinfo.award_fk == '12'">
          <template v-for="(item, index) in items">
            <tr :key="index">
              <td class="col-auto d-lg-table-cell w-1">
                <strong class="text-black">{{
                  item.eventwinningrankinfo.rank
                }}</strong>
              </td>
              <td class="col-auto d-lg-table-cell text-start">
                <MemberInfo
                  :nickname="item.eventwinningrankinfo.nickname"
                  :playerno="item.eventwinningrankinfo.playerno"
                  :member_img="item.eventwinningrankinfo.member_img"
                  :badge_img="item.eventwinningrankinfo.badge_img"
                />
              </td>
              <td class="col-auto d-none d-xxl-table-cell">
                <template v-for="(course, index_nm) in item.coursescore">
                  {{ index_nm > 0 ? " / " : "" }}
                  <span :key="index_nm + 'm'"
                    >{{ course.coursename }} {{ course.subcoursename }}({{
                      item.eventwinningrankinfo.hole
                    }}H)
                  </span>
                </template>
              </td>
              <td class="col-auto d-none d-xl-table-cell shop-name">
                {{ item.eventwinningrankinfo.shopname }}
              </td>
              <td class="col-auto d-none d-sm-table-cell">
                {{ item.eventwinningrankinfo.nearpin }}m
              </td>
              <td class="col-auto d-none d-md-table-cell text-red">
                {{ item.eventwinningrankinfo.entrycnt }} /
                {{ item.eventwinningrankinfo.entrylimit | transToValue("∞") }}
              </td>

              <td
                class="col-auto d-none d-md-table-cell text-point-sp"
                v-if="eventinfo.standard_point != 0"
              >
                {{
                  item.eventwinningrankinfo.standard_points
                    | comma
                    | suffix("P")
                }}
              </td>
              <!-- <td class="col-auto d-none d-xxl-table-cell">
                {{ item.eventwinningrankinfo.newperiolastscore | comma }}
              </td> -->
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-xxl-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="7">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.course") }}
                    </div>
                    <div class="col-8">
                      <template v-for="(course, index_nm) in item.coursescore">
                        {{ index_nm > 0 ? " / " : "" }}
                        <span :key="index_nm + 'm'"
                          >{{ course.coursename }} {{ course.subcoursename }}
                        </span>
                      </template>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.hole") }}
                    </div>
                    <div class="col-8">
                      {{ item.eventwinningrankinfo.hole }}H
                    </div>
                  </div>

                  <div class="row d-xl-none">
                    <div class="col-4">
                      {{ $t("title.common.location") }}
                    </div>
                    <div class="col-8 shop-name">
                      {{ item.eventwinningrankinfo.shopname }}
                    </div>
                  </div>

                  <div class="row d-sm-none">
                    <div class="col-4">
                      {{ $t("title.common.distance") }}
                    </div>
                    <div class="col-8">
                      {{ item.eventwinningrankinfo.nearpin }}m
                    </div>
                  </div>

                  <div class="row d-md-none">
                    <div class="col-4">
                      {{ $t("title.common.no_of_play") }}
                    </div>
                    <div class="col-8 text-red">
                      {{ item.eventwinningrankinfo.entrycnt }} /
                      {{
                        item.eventwinningrankinfo.entrylimit | transToValue("∞")
                      }}
                    </div>
                  </div>

                  <div
                    class="row d-md-none"
                    v-if="eventinfo.standard_point != 0"
                  >
                    <div class="col-4">
                      {{ $t("title.common.standard_point") }}
                    </div>
                    <div class="col-8 text-point-sp">
                      {{
                        item.eventwinningrankinfo.standard_points
                          | comma
                          | suffix("P")
                      }}
                    </div>
                  </div>
                  <!-- <div class="row">
                    <div class="col-4">Final Score<br />(Correction value)</div>
                    <div class="col-8">
                      {{ item.eventwinningrankinfo.newperiolastscore | comma }}
                    </div>
                  </div> -->
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="7" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="page_total"
        v-model="searchData.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <a class="page-link" v-if="active">{{ page }}</a>
          <a class="page-link" v-else>{{ page }}</a>
        </template>
      </b-pagination-nav>

      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="outline-primary"
          :aria-label="$t('button.common.list')"
          @click="$router.push({ name: 'MiniGameList' })"
        >
          {{ $t("button.common.list") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import ax from "@/api/event";
import "@/filter/common";
import { myMixin } from "@/mixin/myMixin";

export default {
  name: "MiniGameRank",
  data() {
    return {
      searchData: {
        gender: this.$route.query.gender || 0,
        pageno: this.$route.query.pageno || 1,
        eventno: this.$route.params.eventno || 0,
      },
      page_total: 1,
      total_cnt: 0,
      data_yn: true,
      rows: 9999,
      items: [],
      view_hide: null,
      eventinfo: {},
      awardprizeranklist: [],
    };
  },
  watch: {
    "searchData.gender": function () {
      this.searchData.pageno = 1;
      this.get_eventwinningranklist();
    },

    "searchData.pageno": function () {
      this.get_eventwinningranklist();
    },
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
      this.$router
        .push({
          query: {
            gender: this.searchData.gender,
          },
        })
        .catch(() => {});
    },

    get_eventwinningranklist() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      console.log("this.searchData", this.searchData);
      ax.get_eventwinningranklist(this.searchData, (flag, data) => {
        if (flag) {
          if (data.eventwinningrankcnt <= 0) {
            this.data_yn = false;
          } else {
            this.data_yn = true;
          }
          this.total_cnt = data.eventwinningrankcnt;
          this.page_total = Math.ceil(data.eventwinningrankcnt / this.rows);
          this.items = data.eventwinningranklist;
          this.eventinfo = data.eventinfo;
          this.awardprizeranklist = data.awardprizeranklist;
        } else {
          alert(data.message);
          this.data_yn = false;
          this.page_total = 0;
        }
      });
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
  mounted() {
    this.get_eventwinningranklist();
  },
  mixins: [myMixin],
};
</script>
